import { render, staticRenderFns } from "./SocialNetworks.vue?vue&type=template&id=dff5bbf4&scoped=true"
import script from "./SocialNetworks.vue?vue&type=script&lang=ts"
export * from "./SocialNetworks.vue?vue&type=script&lang=ts"
import style0 from "./SocialNetworks.vue?vue&type=style&index=0&id=dff5bbf4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff5bbf4",
  null
  
)

export default component.exports